/* @flow */

import * as React from 'react';
import { defineMessages, injectIntl } from 'react-intl';
import { BasicSelect } from 'dibs-elements/exports/BasicSelect';
import formStyles from '../styles/FormGeneral.scss';

type SelectOption = {|
    value: number | string,
    label: string,
|};

type ComponentProps = {
    intl: intlShape,
    countryOptions: Array<SelectOption>,
    errorMessage: string,
    onChange: (e: SyntheticEvent<HTMLSelectElement>) => void,
    value: string,
};

const messages = defineMessages({
    placeholder: {
        id: 'abt.matchmaker.form.country_placeholder',
        defaultMessage: 'Country',
    },
});

const CountryComponent = ({
    countryOptions,
    intl,
    errorMessage,
    onChange,
    value,
}: ComponentProps) => {
    return (
        <div className={formStyles.formWrapper}>
            <BasicSelect
                dataTn="matchmaker-input-country"
                errorMessage={errorMessage}
                placeholder={intl.formatMessage(messages.placeholder)}
                options={countryOptions}
                value={value}
                onChange={onChange}
            />
        </div>
    );
};

export const Country = injectIntl(CountryComponent);
